import moment from "moment"


const TimeCell = ({ startTime }) => {
    if (!startTime) return '-'

    return moment.utc(startTime).local().format('HH:mm')
}

export default TimeCell